import React, { FC } from 'react'

export const HangupIcon: FC<React.SVGProps<SVGSVGElement>> = React.memo(
  ({ width = 24, height = 10, fill = '#000', ...props }) => (
    <svg width={width} height={height} {...props} viewBox='0 0 24 10'>
      <path
        d='M1.182 2.934C2.757 1.344 6.257.044 11.984 0c8.192.022 11.95 2.453 11.973 4.983l.023 3.013c.079.392-.079.717-.394 1.03-.236.235-.63.482-1.035.403l-4.929.034a1.414 1.414 0 01-1.44-1.411l.067-1.982c-1.361-.549-2.79-.851-4.22-.84-1.429.011-2.858.336-4.208.907l.011 1.904a1.413 1.413 0 01-1.418 1.433l-4.951.023a1.407 1.407 0 01-1.44-1.412L0 5.073c.158-.795.551-1.5 1.182-2.139zm21.493 2.06c-.09-2.138-4.805-3.762-10.69-3.717C5.941 1.31 1.417 3 1.35 5.14v.157l.023 3.012c0 .157 0 .157.157.157l4.93-.033c.157 0 .157 0 .157-.157l-.09-2.934.394-.079c3.252-1.523 6.988-1.478 10.183-.078l.394.078.023 2.688c0 .157 0 .157.157.157l4.85.045.08-.079.078-.078-.011-3.001z'
        fill={fill}
      />
    </svg>
  )
)
